// import { useDispatch } from "react-redux";
import httpRequest from "services/httpRequest";
// import { setProgress } from "stores/slices/mediaContent";

const prefix = "/api/media-content";
export const onUploadMediaContent = async params => {
  // const dispatch = useDispatch();
  const formData = new FormData();
  formData.append("file", params.file);
  const result = await httpRequest({
    url: `${prefix}`,
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    params: {
      cannedAccessControlList: params.cannedAccessControlList,
      conversationId: params.conversationId,
      messageId: params.messageId,
    },
    data: formData,
  });
  return result;
};

export const onGetDetailMediaContent = async params => {
  const result = await httpRequest({
    url: `${prefix}/${params.id}`,
    method: "GET",
    params: params,
  });
  if (result) {
    return result;
  }
  return {};
};

export const onCompleteMediaContent = async messageId => {
  const result = await httpRequest({
    url: `${prefix}/complete/${messageId}`,
    method: "PUT",
  });
  return result;
};
